// extracted by mini-css-extract-plugin
export default {"title-page":"TitlePageText_title-page__-5IDV"};